import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContainerClient, BlobServiceClient } from '@azure/storage-blob';

@Injectable({
  providedIn: 'root',
})
export class PatientEmrDetailsService {
  getPatientEhrDetailsUrl: string = 'api/AdminEhr/GetPatientEhrTransactions';
  getPatientEhrPrescriptionsUrl: string = 'api/AdminEhr/GetPatientEhrPrescriptions';
  getPatientEhrHospitalProceduresUrl: string = 'api/AdminEhr/GetPatientHospitalProcedures';
  getPatientEhrPrescriptionDetailsUrl: string = 'api/AdminEhr/GetPatientEhrPrescriptionDetails';
  getPatientEhrPrescriptionFilesUrl: string = 'api/AdminEhr/GetPatientEhrUploadedFiles';
  getPatientEhrHospitalprocedureFilesUrl: string = 'api/AdminEhr/GetPatientEhrUploadedFiles';
  getPatientAllVitalsDataUrl:string = 'api/AdminEhr/GetPatientVitlas';
  constructor(private http: HttpClient) { }

  getPatientEhrDetails(patientId): Observable<any> {
    let params = new HttpParams().set('patientId', patientId);

    return this.http.get(this.getPatientEhrDetailsUrl, { params: params });
  }

  getPatientEhrPrescriptions(patientId, creatorTypeId, currentPage, pageSize): Observable<any> {
    let params = new HttpParams()
      .set('patientId', patientId)
      .set('creatorTypeId', creatorTypeId)
      .set('currentPage', currentPage)
      .set('pageSize', pageSize);

    return this.http.get(this.getPatientEhrPrescriptionsUrl, { params: params });
  }

  getPatientEhrHospitalProcedures(patientId, creatorTypeId, currentPage, pageSize): Observable<any> {
    let params = new HttpParams()
      .set('patientId', patientId)
      .set('creatorTypeId', creatorTypeId)
      .set('currentPage', currentPage)
      .set('pageSize', pageSize);

    return this.http.get(this.getPatientEhrHospitalProceduresUrl, { params: params });
  }

  getPatientEhrPrescriptionDetails(prescriptionId, patientId): Observable<any> {
    let params = new HttpParams()
      .set('ehrTransactionId', prescriptionId)
      .set('patientId', patientId);

    return this.http.get(this.getPatientEhrPrescriptionDetailsUrl, {
      params: params,
    });
  }

  getPatientEhrPrescriptionFiles(prescriptionId, patientId): Observable<any> {
    let params = new HttpParams()
      .set('ehrTransactionId', prescriptionId)
      .set('patientId', patientId);

    return this.http.get(this.getPatientEhrPrescriptionFilesUrl, {
      params: params,
    });
  }

  getPatientEhrHospitalprocedureFiles(hospitalProcedureId, patientId): Observable<any> {
    let params = new HttpParams()
      .set('ehrTransactionId', hospitalProcedureId)
      .set('patientId', patientId);

    return this.http.get(this.getPatientEhrHospitalprocedureFilesUrl, {
      params: params,
    });
  }

  containerClient(containerName: string): ContainerClient {
    return new BlobServiceClient(
      `https://limitlesscarestorage.blob.core.windows.net`
    ).getContainerClient(containerName);
  }

  downloadFile(name: string, handler: (blob: Blob) => void) {
    let urlSplitted = name.split('/');

    let blocClient = urlSplitted.splice(4).join('/');

    const blobClient = this.containerClient(urlSplitted[3]).getBlobClient(
      blocClient
    );

    blobClient.download().then((response) => {
      response.blobBody.then((blob) => {
        handler(blob);
      });
    });
  }

  getPatientAllVitals(patientId, currentPage, pageSize):Observable<any>{
    let params = new HttpParams()
    .set ('patientId', patientId)
    .set ('currentPage', currentPage)
    .set ('pageSize', pageSize);

    return this.http.get (this.getPatientAllVitalsDataUrl, {params: params});
  }
}
